/**
 * Панель свойств выделенного комментария: к чему он привязан, остальные комментарии
 * того же объекта с кнопкой «Добавить ещё», отвязка и удаление.
 *
 * Текст, шрифт и цвет правят на самом плане (двойной клик, меню ▾) — здесь только связь
 * с объектом: она не видна по самой выноске, а важна, ведь комментарий живёт в слое объекта.
 */
import { useProjectStore } from "@/shared/store";
import { useCommentsStore } from "@/shared/store/layers";
import { UIKit } from "@/shared/ui";
import { useEditorStore } from "@/widgets/editor";
import { commentAnchor, commentLayer } from "@/widgets/comments";
import { ObjectComments, commentTargetLabel } from "./ObjectComments";

export const CommentProperties = ({ id }: { id: string }) => {
	const layers = useProjectStore((s) => s.project.layers);
	const pushHistory = useProjectStore((s) => s.pushHistory);
	const setSelection = useEditorStore((s) => s.setSelection);
	const comment = layers.comments.items[id];
	if (!comment) return null;
	const target = comment.target;
	// Объект мог пропасть (стену разрезали) — тогда комментарий фактически свободный
	const attached = commentLayer(comment, layers) !== null;

	return (
		<>
			<UIKit.Text className="text-sm font-semibold tracking-label text-ink uppercase">
				Комментарий
			</UIKit.Text>
			{target && attached ? (
				<>
					<UIKit.Text className="text-sm text-ink">
						Привязан к объекту: <b>{commentTargetLabel(layers, target)}</b>. Стрелка следует за ним,
						комментарий скрывается вместе с его слоем.
					</UIKit.Text>
					<ObjectComments kind={target.kind} id={target.id} currentId={id} />
					<UIKit.Button
						type="button"
						className="rounded-lg px-2.5 py-2 text-sm"
						onClick={() => {
							pushHistory();
							useCommentsStore
								.getState()
								.updateComment(id, { anchor: commentAnchor(comment, layers), target: undefined });
						}}
					>
						Отвязать от объекта
					</UIKit.Button>
				</>
			) : (
				<UIKit.Text className="text-sm leading-snug text-ink">
					Свободный: стрелка указывает на точку плана. Чтобы привязать к предмету, розетке, двери
					или стене — протяните конец стрелки на него.
				</UIKit.Text>
			)}
			<UIKit.Button
				type="button"
				className="mt-1 rounded-lg border border-red-200 bg-red-50 px-2.5 py-2 text-sm text-danger hover:bg-red-50"
				onClick={() => {
					pushHistory();
					useCommentsStore.getState().removeComment(id);
					setSelection(null);
				}}
			>
				Удалить комментарий
			</UIKit.Button>
		</>
	);
};
